import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import useRouter from "hooks/useRouter";
import { deleteStudy, clearStudyAction } from "actions/studies/studyActions";

import history from "../../history";

const StudyDelete = ({ formId, closeModal, selected }) => {
  const routingParams = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearStudyAction());
    };
  }, [dispatch]);

  const handleDelete = e => {
    e.preventDefault();
    dispatch(deleteStudy(selected));
    if (
      routingParams.match.path === "/studies/:id" ||
      routingParams.match.path === "/studies/:id/edit"
    ) {
      history.push("/studies");
    } else {
      closeModal();
    }
  };

  return (
    <form
      id={formId}
      onSubmit={e => handleDelete(e)}
      className="form container"
    >
      <div>
        Are you sure you want to delete this study? This can not be undone.
      </div>
    </form>
  );
};

export default StudyDelete;
